import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import { UseFormMethods } from 'react-hook-form/dist/types/form';
import { FormElement } from 'src/front/components/FormStyles';
import { useTranslation } from 'react-i18next';
import Datepicker from 'src/front/components/Datepicker';
import { IdentityFormData } from 'src/front/components/identity/IdentityFormData';

interface Props {
  formMethods: UseFormMethods<IdentityFormData>;
  onChangeHandler: (fieldName: 'issueDate') => (date: Date) => void;
}
const IssueDate: FC<Props> = ({ formMethods, onChangeHandler }) => {
  const { control, errors } = formMethods;
  const { t } = useTranslation();

  return (
    <FormElement>
      <Controller
        control={control}
        name="issueDate"
        render={({ onChange, value }) => (
          <Datepicker
            errorMessage={t(errors?.issueDate?.message as string)}
            inputLabel={`${t('general_issueDate_label')} *`}
            onChange={(date) => {
              onChange(date);
              onChangeHandler('issueDate')(date as Date);
            }}
            value={value as Date}
          />
        )}
      />
    </FormElement>
  );
};

export default IssueDate;
